import React, { useState, useContext, useRef } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import money_rounding from "../../utils/money_rounding";
import moment from "moment/moment";
import iqd_rounding from "../../utils/iqd_rounding";
import Customer_invoice_item_ledger_modal from "./customer_invoice_item_ledger_modal";
import Sellitemprint from "../sell/sellitemprint";

const Customer_invoice_ledger_table = ({invoice}) => {
    const { initState, recaller, setrecaller, initDispatch, clear } =
        useContext(GlobalContext);

    const [invoiceno, setinvoiceno] = useState(0);
    const [invoice_detail, setinvoice_detail] = useState({});
    const [show, setshow] = useState(false);

    const printit=(invoiceno)=>{
        setinvoiceno(invoiceno);
        setTimeout(() => {
        window.print();
        }, 500);
    }
    return (
        <>
        <Sellitemprint username={initState.token.username} items={invoice_detail?invoice_detail?.items:[]} invoiceno={invoiceno} />
        <div className="print_hide">
            <Customer_invoice_item_ledger_modal show={show} setshow={setshow} invoice_detail={invoice_detail} printit={printit}/>
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto"> 
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                    <h2 className="text-base font-semibold text-slate-800">لیستی پسوڵەی فرۆشراو</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                <thead>
                    <tr className="bg-slate-50 border-b border-slate-100">
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            ژمارەی پسوڵە
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            کڕیار
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            جۆری پسوڵە
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            بەروار
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            کۆی نرخی پسوڵە
                        </th>
                    </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                    {invoice?.map((lis, index) => (
                        <tr
                        key={index}
                        className="hover:bg-slate-50 transition-colors duration-100 cursor-pointer"
                        onClick={() => {
                            setinvoice_detail(lis);
                            setshow(true);
                        }}
                        >
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {lis.sell_invoice_id}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {lis.customer_name}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {lis.sell_invoice_type=="loan"?"قەرز":"کاش"}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            <p className="text-slate-800 whitespace-no-wrap" dir="ltr">
                            {moment(lis.sell_invoice_date).format("YYYY-MM-DD hh:mm A")}
                            </p>
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {numberbeautify(
                                iqd_rounding(
                                Number(lis.items.reduce((acc, item) => {
                                return acc + (item.item_sell_price * item.item_qty);
                            }
                            , 0))))
                            } IQD
                        </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
            </div>
        </>
    )
}

export default Customer_invoice_ledger_table